import { isValidPhoneNumber } from 'libphonenumber-js'

(function ($) {
  'use strict'

  window.AOS.init({
    duration: 800,
    easing: 'slide',
    once: false
  })

  const select = (el, all = false) => {
    el = el.trim()
    if (all) {
      return [...document.querySelectorAll(el)]
    } else {
      return document.querySelector(el)
    }
  }

  /**
   * Easy event listener function
   */
  const on = (type, el, listener, all = false) => {
    let selectEl = select(el, all)
    if (selectEl) {
      if (all) {
        selectEl.forEach(e => e.addEventListener(type, listener))
      } else {
        selectEl.addEventListener(type, listener)
      }
    }
  }

  /**
   * Mobile nav toggle
   */
  on('click', '.mobile-nav-toggle', function(e) {
    select('#navbar').classList.toggle('navbar-mobile')
    this.classList.toggle('text-white')
  })

  $('.slider.center').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 560,
        settings: {
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  })

  $.validator.addMethod("phoneNumber", function (value, element) {
      return isValidPhoneNumber(value, 'RO')
    }, 'Invalid phone number'
  )
})(jQuery)
